import { Card } from '@material-ui/core';
import * as moment from 'moment';
import React from 'react';
import { isMobile } from 'react-device-detect';
import BasicTab from '../../../components/form/BasicTab';
import TabPanel from '../../../components/layout/TabPanel';


const OngletOt = (props) => {
  const { width, classes, value, ots, handleOpenCommentOt, generateCardOt, auth, wsStatus } = props;

  if (isMobile) {
    return (
      <TabPanel className={classes.tabPanel} value={value} index={3}>
        <div className="row" style={{ flexDirection: 'column', borderBottom: '2px solid #E4E8EC', paddingBottom: '10px' }}>
          <div className="title-sub-rubrique" style={{ fontSize: '2.5vw', margin: '8px 0 20px 0' }}>Historique des ots</div>
          <div className='list-card'>
          {
            ots.map((anOt, j) => {
              return (
                <Card key={'paper-alarm-' + j} className={classes.cardOt} onClick={() => handleOpenCommentOt(anOt)}>
                  <div className='card-ot-icon'>
                    {generateCardOt(anOt)}
                  </div>
                  <div className='card-ot-detail'>
                    <div className='card-ot-header'>
                      <div className='card-ot-date'>{anOt.dateDeb ? moment(anOt.dateDeb).format('DD/MM/YYYY à HH:mm') : ''}</div>
                      <div>{anOt.jobType} - {anOt.id} - {anOt.priorite.code}</div>
                    </div>
                    <div>{anOt.jobDescription}</div>
                  </div>
                </Card>
              );
            })
          }
          {
            (!ots || ots.length === 0) &&
            <div style={{ display: 'flex', justifyContent: 'center' }}><h5>Aucune donnée à afficher</h5></div>
          }
          </div>
        </div>
      </TabPanel>
    );
  }

  return (
    <TabPanel className={classes.tabPanel} value={value} index={3} style={{ width: '100%' }}>
      <div className="overflow-auto" style={{ overflow: 'auto', height: 'calc(90vh - 145px)' }}>
        <div className="row" style={{ flexDirection: 'column' }}>
          <div className="title-sub-rubrique" style={{ fontSize: '1vw' }}>Historique des ots</div>
          <BasicTab
            style={{
              header: {
                row: {
                  backgroundColor: '#F0F3F6',
                  fontSize: width > 1400 ? '0.75vw' : '1vw',
                },
              },
              datas: {
                row: {
                  borderBottom: '1px solid #EBEEF1',
                  fontSize: width > 1400 ? '0.75vw' : '1vw',
                },
              },
            }}
            width={'100%'}
            headers={['date création', 'description equipement', 'type', 'priorité', 'description intervention', 'statut', '']}
            columns={['dateDeb', 'eqpDescription', 'jobType', 'priorite', 'jobDescription', 'userStatus', ]}
            datas={ots}
            openExternalTab={'url'}
            showDetail={true}
            setNeedUpdate={null}
            handleOpenDetail={handleOpenCommentOt}
            auth={auth}
            wsStatus={props.wsStatus}
          />
        </div>
      </div>
    </TabPanel>
  );

};

export default OngletOt;